export default __webpack_public_path__ + "static/media/cladding25.388bfa40.jpg";